// ============================================================
// Datei: ShiftTableDesktop.jsx
// ============================================================

import "./shiftTable.css";
import "../../styles/toggleSwitch.css";

const ShiftTableDesktop = ({
	shifts,
	onToggleVisibility
}) => {

	return (
		<div className="shift-table-wrapper">


			<div className="shift-table-container">
				<table className="shift-table">
					<thead>
						<tr>
							<th>Tag</th>
							<th>Start</th>
							<th>Ende</th>
							<th>Angefragt</th>
							<th>Zugewiesen</th>
							<th>Status</th>
							<th>Sichtbarkeit</th>
							<th>Libellen</th>
						</tr>
					</thead>

					<tbody>
						{shifts.length > 0 ? (
							shifts.map((shift) => {

								const isFull =
									shift.bookedShift >= shift.requestedAmountOfVolunteers;

								const hasPublic =
									shift.publicSlots > 0 && !isFull;
									

								return (
									<tr
										key={shift.shiftId}
										className={`
											shift-row
											${isFull ? "full" : ""}
											${hasPublic ? "has-public" : ""}
										`}
									>
										<td>{shift.dayOfDeployment}</td>
										<td>{shift.startTime}</td>
										<td>{shift.endTime}</td>
										<td>{shift.requestedAmountOfVolunteers}</td>
										<td>{shift.bookedShift}</td>

										{/* STATUS */}
										<td className={isFull ? "shift-status-full" : "shift-status-open"}>
											{isFull ? "Belegt" : "Offen"}
										</td>

										{/* SICHTBARKEIT */}
										<td className="visibility-toggle-cell">
											{!isFull && (
												<>
													<span
														className={
															shift.shiftVisibility === "PUBLIC"
																? "visibility-label public"
																: "visibility-label private"
														}
													>
														{shift.shiftVisibility === "PUBLIC" ? (
															<>
																Öffentlich{" "}
																<span className="public-slots">
																	({shift.publicSlots}/{shift.requestedAmountOfVolunteers})
																</span>
															</>
														) : (
															"Intern"
														)}
													</span>

													<label className="switch">
														<input
															type="checkbox"
															checked={shift.shiftVisibility === "PUBLIC"}
															onChange={() => onToggleVisibility(shift)}
														/>
														<span className="slider round"></span>
													</label>
												</>
											)}
										</td>

										{/* HELFER */}
										<td className="shift-volunteers-cell">
											{shift.volunteerNames?.length > 0 ? (
												<ul className="shift-volunteer-list">
													{shift.volunteerNames.map((name, index) => (
														<li key={index}>{name}</li>
													))}
												</ul>
											) : (
												<em className="shift-no-volunteers">Keine</em>
											)}
										</td>
									</tr>
								);
							})
						) : (
							<tr>
								<td colSpan={8} className="shift-table-empty">
									<em>Aktuell sind keine Schichten vorhanden.</em>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ShiftTableDesktop;
